// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationsContainer_container__1TwW6","hidden":"NotificationsContainer_hidden__2ObwS"};